import script from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"

import "./CardNameTitle.vue?vue&type=style&index=0&id=1e73735a&lang=scss&scoped=true"
script.__scopeId = "data-v-1e73735a"

export default script